import React, { Fragment } from "react";
import { FiTrash, FiUpload } from "react-icons/fi";
import { FaSpinner } from "react-icons/fa";
import flex from "../../../styles/flex";
import ErrorDialog from "../../notifications/errorDialog/ErrorDialog";
import { usePhotoPickerLogic } from "./usePhotoPicker";

const PhotoPickerCompact: React.FunctionComponent<{
    fileName: string;
    width: number;
    height: number;
    scale: number;
    ignoreSizeConstraints?: boolean;
    readonly?: boolean;
    onUpdated: (fileName: string) => void;
}> = (props) => {
    const {
        url,
        uploading,
        uploadErr,
        inputRef,
        onFileSelected,
    } = usePhotoPickerLogic(
        props.fileName,
        props.width,
        props.height,
        props.scale,
        props.onUpdated,
        props.ignoreSizeConstraints
    );

    return (
        <Fragment>
            <ErrorDialog err={uploadErr}></ErrorDialog>
            <div
                onClick={props.readonly == true ? undefined : () => inputRef.current?.click()}
                style={{
                    border: "solid 2px #eee",
                    backgroundColor: "#eee",
                    cursor: props.readonly == true ? "default" : "pointer",
                    height: props.height * props.scale,
                    width: props.width * props.scale,
                    position: "relative",
                    backgroundImage: `${url.length === 0 ? "none" : `url(${url})`}`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                }}
            >
                <div
                    style={{
                        width: 40,
                        height: 40,
                        position: "absolute",
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        marginLeft: "auto",
                        marginRight: "auto",
                        marginTop: "auto",
                        marginBottom: "auto",
                    }}
                >
                    {uploading === true && <FaSpinner size={40}></FaSpinner>}
                </div>
            </div>
            <input
                style={{ visibility: "collapse", position: "fixed", left: -1000 }}
                type="file"
                accept="image/jpeg, image/png"
                ref={inputRef}
                onChange={(e) => {
                    const file = e.target?.files?.item(0);
                    if (file == null) return;
                    onFileSelected(file);
                }}
            />
            <div style={{ height: 10 }}></div>
            <div style={flex.flexRows}>
                <div style={{ ...flex.flexAuto, textAlign: "left" }}>
                    {props.readonly !== true && uploading === false && (
                        <a
                            onClick={() => {
                                if (uploading) return null;
                                inputRef.current?.click();
                            }}
                            style={{ fontSize: "25px", cursor: "pointer" }}
                        >
                            <FiUpload></FiUpload>
                        </a>
                    )}
                </div>
                <div style={flex.flexFill}></div>
                <div style={{ ...flex.flexAuto, textAlign: "right", height: 35 }}>
                    {props.readonly !== true && uploading === false && url.length > 0 && (
                        <a
                            onClick={() => {
                                if (uploading) return null;
                                props.onUpdated("");
                            }}
                            style={{ fontSize: "25px", cursor: "pointer" }}
                        >
                            <FiTrash></FiTrash>
                        </a>
                    )}
                </div>
            </div>
        </Fragment>
    );
};

export default PhotoPickerCompact;